import { Box, spacing } from "@procore/core-react";

import { useAppSelector } from "app/redux-store-interactions";
import { selectInitHomeViewpointId, selectProcoreContext, selectSceneId } from "slices/explorer";

import { ExternalLink, Section } from "./common";

/** @param props.procoreOrigin Links stay disabled while it is unknown. */
export function LinksSection({ procoreOrigin }: { procoreOrigin: string | undefined }) {
    const sceneId = useAppSelector(selectSceneId);
    const procoreContext = useAppSelector(selectProcoreContext);
    const homeViewpointId = useAppSelector(selectInitHomeViewpointId);

    const adminUrl =
        procoreContext && sceneId && procoreOrigin
            ? `${procoreOrigin}/webclients/host/companies/${procoreContext.companyId}/projects/${procoreContext.projectId}/tools/bim-platform-admin/scenes/${sceneId}` +
              (procoreContext.sceneVersionId ? `/versions/${procoreContext.sceneVersionId}` : "")
            : undefined;

    const modelManagerUrl =
        procoreContext && procoreOrigin
            ? `${procoreOrigin}/webclients/host/companies/${procoreContext.companyId}/projects/${procoreContext.projectId}/tools/bimmodelmanager`
            : undefined;

    const mobileUrl = (() => {
        if (!procoreContext || !sceneId || !procoreOrigin) {
            return undefined;
        }
        const params = new URLSearchParams({ platform: "ios", scene_id: sceneId });
        if (procoreContext.sceneVersionId) {
            params.set("scene_version_id", procoreContext.sceneVersionId);
        }
        if (procoreContext.sceneSliceId) {
            params.set("scene_slice_id", procoreContext.sceneSliceId);
        }
        if (homeViewpointId) {
            params.set("home_viewpoint_id", homeViewpointId);
        }
        return `${procoreOrigin}/${procoreContext.projectId}/project/models/mobile_viewer?${params}`;
    })();

    return (
        <Section title="Links">
            <Box style={{ display: "flex", flexWrap: "wrap", gap: spacing.lg }}>
                <ExternalLink href={adminUrl}>bim-platform-admin</ExternalLink>
                <ExternalLink href={modelManagerUrl}>Model manager</ExternalLink>
                <ExternalLink href={mobileUrl}>Mobile</ExternalLink>
            </Box>
        </Section>
    );
}
